import React, {useCallback} from 'react'
import ListItem, {BaseProps} from './ListItem'
import {ColInfo, ColPhoto, ColStat} from '../Col'
import styles from '../../../../CSS/main.css'
import classNames from 'classnames'
import {useNavigation} from '../../../utils/navigation'
import {WebsiteItem as WebsiteItemType} from "../../../../../types";
import {Routes} from "../../../routing";

export type Website = WebsiteItemType

export enum WebsiteStatus {
  Enabled = 'enabled',
  Disabled = 'disabled',
}

export enum WebsiteCommentsStatus {
  Enabled = 'enabled',
  Disabled = 'disabled',
}

export type Props = {
  readonly website: Website
} & BaseProps

const SitesItem: React.VFC<Props> = ({
  onSelected,
  selected,
  options,
  website,
}) => {
  const { goTo } = useNavigation()

  const navigateToSite = useCallback(() => {
    goTo(Routes.EditWebsite, { id: encodeURIComponent(website.name) })
  }, [])

  return (
    <ListItem
      onClick={navigateToSite}
      onSelected={onSelected}
      selected={selected}
      options={options}>
      <ColPhoto>
        <div
          className={
            website.disabled
              ? styles.WebsiteDisabled
              : styles.WebsiteEnabled
          }
        />
      </ColPhoto>
      <ColInfo>
        <p className={classNames([styles.InfoBig, styles.Ellipsis])}>
          {website.name}
        </p>
        <p className={classNames([styles.InfoSmall, styles.Ellipsis])}>
          https://{website.name}
        </p>
      </ColInfo>
      <ColStat>
        {website.disabled ? 'Disabled' : 'Enabled'}
      </ColStat>
    </ListItem>
  )
}

export default SitesItem
